import {Dispatch, SetStateAction} from "react";
import Alert from 'react-bootstrap/Alert';
import {Placement} from 'react-bootstrap/types';
import {Truncate} from "./Truncate";

export interface AlertProps {
    message : string | undefined
    setMessage?: Dispatch<SetStateAction<string | undefined>>
    variant? : "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark"
    tooltipPlacement?: Placement
}

/**
 * Shows an alert if the error message is set, i.e., is defined
 */
export const RenderAlert = ({message, setMessage, tooltipPlacement, variant = "danger"}: AlertProps) => {
    if (message != undefined) {
        return (
            <Alert className="text-break" variant={variant} onClose={() => {if (setMessage !== undefined) setMessage(undefined)}}>
                <Truncate value={message} maxLength={240} placement={tooltipPlacement} />
            </Alert>
        );
    }
};
